"use client";

import React from 'react';
import { motion } from 'framer-motion';
import { GoogleMapsEmbed } from '@next/third-parties/google';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from 'next-i18next';
interface ModernGoogleMapProps {
  companyName: string;
  address: string;
  mapQuery: string;
  visitUsUrl: string;
}
const ModernGoogleMap: React.FC<ModernGoogleMapProps> = ({
  companyName,
  address,
  mapQuery,
  visitUsUrl
}) => {
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "";
  const {
    t
  } = useTranslation('common');
  const handleVisitUsClick = () => {
    window.open(visitUsUrl, '_blank');
  };
  return <Card className="w-full max-w-7xl mx-auto overflow-hidden mt-6" data-sentry-element="Card" data-sentry-component="ModernGoogleMap" data-sentry-source-file="modern-contact-map.tsx">
      <CardContent className="p-0 relative" data-sentry-element="CardContent" data-sentry-source-file="modern-contact-map.tsx">
        <div className="relative w-full h-[600px]">
          <GoogleMapsEmbed apiKey={apiKey} height="600" width="100%" mode="place" q={mapQuery} allowfullscreen loading="lazy" data-sentry-element="GoogleMapsEmbed" data-sentry-source-file="modern-contact-map.tsx" />
          <motion.div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1
        }} data-sentry-element="unknown" data-sentry-source-file="modern-contact-map.tsx" />
          <motion.div className="absolute bottom-0 left-0 right-0 p-6 text-white flex flex-col" initial={{
          y: 50,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} data-sentry-element="unknown" data-sentry-source-file="modern-contact-map.tsx">
            <h2 className="text-2xl font-bold mb-2">{companyName}</h2>
            <p className="text-sm mb-2">{address}</p>
            <Button variant="secondary" size="default" onClick={handleVisitUsClick} className="mt-2 w-full w-fit" data-sentry-element="Button" data-sentry-source-file="modern-contact-map.tsx">
              {t('text-visit-us')}
            </Button>
          </motion.div>
        </div>
        <motion.div className="absolute top-1/2 left-1/2 w-16 h-16 -mt-8 -ml-8" initial={{
        scale: 0.5,
        opacity: 0
      }} animate={{
        scale: [1, 1.2, 1],
        opacity: [1, 0.5, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} data-sentry-element="unknown" data-sentry-source-file="modern-contact-map.tsx">
          <div className="w-full h-full rounded-full bg-primary/30 flex items-center justify-center">
            <div className="w-4 h-4 rounded-full bg-primary" />
          </div>
        </motion.div>
      </CardContent>
    </Card>;
};
export default ModernGoogleMap;